module.exports = __webpack_public_path__ + "img/service-introduction-1.5895b0b7.png";